module.exports = __webpack_public_path__ + "static/media/quote.524970e8.svg";